// https://emojipedia.org
// import store from '../../store';

function getNumberIcon(numberObject, customClass) {
  // const numberIntegrationMap = store.getters['organisation/numberIntegrationMap'];
  const h = this.$createElement;
  let vnode;

  if (!numberObject) {
    return vnode; // TODO users which are are not allowed to acces some numbers should be able to see the number emoji.
  }

  // We decided not to use integration icons for now - 02.07.2024
  // if (!numberIntegrationMap[numberObject.id] || !numberIntegrationMap[numberObject.id].length) {
  vnode = h(
    'span',
    { class: `branch-icon flex center-all emoji-fix ${customClass}` },
    numberObject.emoji,
  );
  // } else if (numberIntegrationMap[numberObject.id] && numberIntegrationMap[numberObject.id].length === 1) {
  //   vnode = h(
  //     'span',
  //     { class: ['branch-icon', 'integration', numberIntegrationMap[numberObject.id][0], customClass] },
  //   );
  // } else {
  //   // TODO this should render something like an integration icon and then count in the top right corner of it
  //   vnode = h(
  //     'span',
  //     { class: `branch-icon count ${customClass}` },
  //     numberIntegrationMap[numberObject.id].length,
  //   );
  // }
  return vnode;
}

function getIntegrationIcon(integration, customClass) {
  const h = this.$createElement;
  return h(
    'span',
    { class: ['integration-icon', integration.code, customClass] },
  );
}

const staticNumberList = [
  '🏠',
  '📞',
  '🏔️',
  '🌋',
  '🏕️',
  '🏝️',
  '🏛️',
  '🏰',
  '🧭',
  '💡',
];

export { getNumberIcon, staticNumberList, getIntegrationIcon };
